import {
  useEffect,
  useState
} from "react";

import { useWindowSize } from "./useWindowSize";

export const useIsMobile = (): boolean => {
  const { width } = useWindowSize();
  const [ isMobile, setIsMobile ] = useState(false);

  useEffect(() => {
    if (width && width < 800 && !isMobile) {
      setIsMobile(true);
    } else if (width && width >= 800 && isMobile) {
      setIsMobile(false);
    }
  }, [ isMobile, width ]);

  return isMobile;
};